// CORE
import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";
import { GenerateTokenService } from 'integrationpingid-lib';

// SERVICES
import { LocalStorageService } from 'src/app/services/shared/local-storage/local-storage.service';

// INTERFACES & ENTITIES
import { Country } from 'src/app/entities/shared/Country';
import { Icountry } from './../../../entities/shared/Country';
import { IMenuData } from './../../../interfaces/shared/menu-home.interface';
import { User } from './../../../entities/shared/User';

import { environment } from 'src/environments/environment';
import { SessionService } from 'src/app/services/shared/session/session.service';
import { NotificationAlertService } from '../notifications-alert/service/notifications-alert.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit {

  sideBarIsOpen: boolean = false;
  toggleHamburgerButtonEmitter = new EventEmitter();
  isVip: boolean = false;
  isExternoRds: boolean = false;
  environmentText: string = environment.ENVIRONMENT;
  notifications

  get publicDM(): boolean {
    return this.localStorageService?.getIsVip || false;
  };

  get menuItems(): IMenuData[] {
    return this.localStorageService?.getMenuConfig;
  };

  get listCountry(): Country[] {
    return this.localStorageService?.getListCountries as unknown as Country[];
  }

  get regionSeleccionada(): Country {
    return this.localStorageService?.getRegionSeleccionada;
  }

  get user(): User {
    return this.localStorageService?.dataLogin;
  }

  constructor(
    private localStorageService: LocalStorageService,
    private router: Router,
    public serviceToken: GenerateTokenService,
    private sessionService: SessionService,
    private notificationAlertService: NotificationAlertService
  ) {
    localStorage.setItem('supplierId', "1");
    localStorage.setItem('supplierCode', "2");
    this.isVip = this.localStorageService.getIsVip;
    this.isExternoRds = this.localStorageService.getIsExternoRDS;

    window.addEventListener("resize", () => {
      if (window.innerWidth <= 880) {
        this.sideBarIsOpen = false;
        this.toggleHamburgerButtonEmitter.emit(this.sideBarIsOpen);
      }
    }, false);
  }

  ngOnInit() {
    this.notifications = this.notificationAlertService.notifications;
  }

  switchCountry(country: Country) {
    if (!this.localStorageService.getIsExternoRDS) {
      this.localStorageService.setRegionSeleccionada = country;
      this.localStorageService.bkpSoftDeleteList = null;
      this.localStorageService.setMenuApp = null;

      // Navegar al home después de cambiar el país
      const homeUrl = this.isVip
        ? environment.URL_RETURN_APP_VIP
        : this.isExternoRds
          ? environment.URL_RETURN_APP_RDS
          : environment.URL_RETURN_APP;

      this.router.navigateByUrl(homeUrl);
    }
  }

  navIconMenu(menuSelect: IMenuData) {
    this.localStorageService.setMenuApp = menuSelect;
    this.routeMenuSelected(menuSelect);
  }

  routeMenuSelected(menuSelect: IMenuData) {
    const isVip = this.localStorageService.getIsVip;
    const isExternoRds = this.localStorageService.getIsExternoRDS;

    const rutaIntExt = isVip
      ? 'routeVip'
      : isExternoRds
        ? 'routeRds'
        : 'route';

    if (menuSelect?.[rutaIntExt]) {
      const country = this.localStorageService.getRegionSeleccionada?.getCode()?.toLowerCase();
      if (country) {
        this.router.navigate([menuSelect[rutaIntExt], country]);
      } else {
        this.router.navigate([menuSelect[rutaIntExt]]);
      }
    } else {
      // Caso especial: Mantenedor/Configuración no tiene ruta, debe navegar al home
      // pero manteniendo el menuApp en localStorage para que menu-home muestre el sub-menú
      const homeUrl = isVip
        ? environment.URL_RETURN_APP_VIP
        : isExternoRds
          ? environment.URL_RETURN_APP_RDS
          : environment.URL_RETURN_APP;

      // Solo navegar si no estamos ya en el home
      if (!this.router.url.includes('/home')) {
        this.router.navigateByUrl(homeUrl);
      }
      // Si ya estamos en home, el cambio de menuApp disparará el observable
      // y menu-home.component se actualizará automáticamente
    }
  }

  showSidebar() {
    this.sideBarIsOpen = !this.sideBarIsOpen;
    this.toggleHamburgerButtonEmitter.emit(this.sideBarIsOpen);
  }

  isSideBarIsOpen(): boolean {
    return this.sideBarIsOpen;
  }

  goToFuentesPage() {
    const stringUrlSource = (this.localStorageService.getIsVip)
      ? 'vip/data-maintenance'
      : (this.localStorageService.getIsExternoRDS)
        ? 'rdsportal/data-maintenance'
        : 'int/data-maintenance';
    const currentCountry = this.localStorageService.getRegionSeleccionada.getCode();
    this.router.navigateByUrl(`/${stringUrlSource}/${currentCountry}/fuentes`);
  }

  goToHome() {
    this.sessionService.goToHome()
  }

  logoutSessionGoToHome() {
    this.sessionService.logoutSessionGoToHome();
  }

  goToReports() { }

  visibleItem(itemMenu) {
    return (this.isVip)
      ? !itemMenu.disabledVip
      : (this.isExternoRds)
        ? !itemMenu.disabledRds
        : !itemMenu.disabled;
  }

}
